import React from 'react';
import { Link } from '@tanstack/react-router';
import { useMe } from '../lib/auth';
import { AuthAPI } from '../lib/api';
import { useQueryClient } from '@tanstack/react-query';
import { useSidebar } from '../lib/sidebar';
import { LogOut, X } from 'lucide-react';

const NAV = [
  { to: '/', label: 'Огляд', emoji: '📊' },
  { to: '/projects', label: 'Проєкти', emoji: '📦' },
  { to: '/tasks', label: 'Задачі', emoji: '📋' },
  { to: '/agents', label: 'Агенти', emoji: '🤖' },
  { to: '/apis', label: 'API', emoji: '💳' },
  { to: '/certs', label: 'Сертифікати', emoji: '🔐' },
  { to: '/domains', label: 'Домени', emoji: '🌐' },
  { to: '/docs', label: 'Документи', emoji: '📜' },
  { to: '/settings', label: 'Налаштування', emoji: '⚙️' },
] as const;

export function Sidebar() {
  const { user } = useMe();
  const qc = useQueryClient();
  const { open, setOpen } = useSidebar();

  async function handleLogout() {
    await AuthAPI.logout().catch(() => {});
    qc.clear();
    window.location.href = '/login';
  }

  return (
    <>
      {open && (
        <div
          onClick={() => setOpen(false)}
          className="fixed inset-0 z-30 md:hidden"
          style={{ background: 'rgba(0,0,0,0.5)' }}
        />
      )}
      <aside
        className={`fixed left-0 top-0 h-full w-60 flex flex-col border-r border-tg-border z-40 transition-transform duration-200 ${
          open ? 'translate-x-0' : '-translate-x-full'
        } md:translate-x-0`}
        style={{ background: 'var(--tg-bg-secondary)' }}
      >
        <div className="px-4 py-4 border-b border-tg-border flex items-center justify-between">
          <div>
            <div className="text-base font-bold text-tg-accent">Cron Admin</div>
            <div className="text-xs text-tg-text-secondary">Адмінка VPS</div>
          </div>
          <button
            onClick={() => setOpen(false)}
            className="md:hidden text-tg-text-secondary p-1"
            aria-label="Close menu"
          >
            <X size={18} />
          </button>
        </div>

        <nav className="flex-1 px-2 py-3 overflow-y-auto">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-tg-text transition-colors mb-0.5"
              activeProps={{ style: { background: 'var(--tg-bg-tertiary)' } }}
              activeOptions={{ exact: item.to === '/' }}
            >
              <span>{item.emoji}</span>
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="px-3 py-3 border-t border-tg-border flex items-center justify-between">
          <div className="flex items-center gap-2 min-w-0">
            {user?.tgPhotoUrl ? (
              <img src={user.tgPhotoUrl} alt="" className="w-7 h-7 rounded-full shrink-0" />
            ) : (
              <div
                className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold shrink-0"
                style={{ background: 'var(--tg-bg-tertiary)' }}
              >
                {user?.tgFirstName?.[0] ?? '?'}
              </div>
            )}
            <span className="text-sm text-tg-text truncate">
              {user?.tgFirstName ?? 'Юзер'}
            </span>
          </div>
          <button
            onClick={handleLogout}
            className="text-tg-text-secondary hover:text-tg-error transition-colors"
            title="Вийти"
          >
            <LogOut size={16} />
          </button>
        </div>
      </aside>
    </>
  );
}
